export function isErrorResponse(response) {
    return response && response.name === 'Foundation::ErrorResponse';
}
export function isPermissionDeniedResponse(response) {
    return response && response.name === 'Foundation::PermissionDeniedResponse';
}
export function isHighLevelResponse(response) {
    return response && response.name === 'Foundation::HighLevelResponse';
}
export function isRejectResponse(response) {
    return response && response.name === 'Foundation::RejectResponse';
}
export function isKeyValueResponse(response) {
    return response && response.name === 'Foundation::KeyValueResponse';
}
export function isKeyValueKeyListResponse(response) {
    return response && response.name === 'Foundation::KeyValueKeyListResponse';
}
export function isHighLevelUpdate(response) {
    return response && response.name === 'Foundation::HighLevelUpdate';
}
export function isInstrumentFieldValueUpdate(response) {
    return response && (response.name === 'Foundation::InstrumentFieldValueUpdate' ||
        response.name === 'Foundation::InstrumentFieldValueCreationUpdate');
}
export function isNotationFieldSubsampleSubscriptionUpdate(response) {
    return response && response.name === 'Foundation::NotationFieldSubsampleSubscriptionUpdate';
}
export function isNotationFieldValueUpdate(response) {
    return response && (response.name === 'Foundation::NotationFieldValueUpdate' ||
        response.name === 'Foundation::NotationFieldValueCreationUpdate');
}
export function isFieldValueResponse(response) {
    return response && response.name === 'Foundation::FieldValueResponse';
}
export function isFieldValueMessage(response) {
    return isFieldValueResponse(response) || isNotationFieldValueUpdate(response) || isInstrumentFieldValueUpdate(response);
}
export function isKeyValueUpdate(response) {
    return response && response.name === 'Foundation::KeyValueUpdate';
}
export function isKeyValueKeyListUpdate(response) {
    return response && response.name === 'Foundation::KeyValueKeyListUpdate';
}
export function isSubscriptionLossMessage(response) {
    return response && response.name === 'Foundation::SubscriptionLossMessage';
}
//# sourceMappingURL=guards.js.map